// baby: Re-export shared 8-bit theme kit (used by /nin and /ninxl)
export {
  Ninxl8BitThemeProvider,
  useNinxl8BitTheme,
  useNinxl8BitThemeMode,
  type Ninxl8BitTheme,
} from '@/app/(marketing)/_components/8bit'
